<template>
  <div>
    <common-dialog
      ref="dialog"
      width="1300px"
      :show-save-button="!readonly"
      unit="课程表"
      id-key="CurriculumId"
      :data="data"
      form-label-width="80px"
      :form-rules="rules"
      :save-func="api.saveV2"
      :before-save="onBeforeSave"
      @edit-opened="onEditOpened"
      @details-opened="onDeatilsOpened"
      @closed="onClosed"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-row>
          <el-col :span="isMB?24:8">
            <el-form-item label="班级" label-width="52px">
              <span style="color:red;">{{ClassName}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="isMB?24:8">
            <el-form-item label="学期名称" prop="TermName">
              <span>{{data.TermName}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="isMB?24:8">
            <el-form-item label="选择星期">
              <week-picker
                ref="weekPicker"
                :s-date="TermStart"
                select-disable
                :e-date="TermEnd"
                @change="onChange"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-table :data="data.Sections" height="650px" :stripe="true" style="width: 100%">
              <el-table-column type="index" label="序号" align="center" width="50"></el-table-column>
              <el-table-column prop="SectionName" label="节次" width="80" align="center"></el-table-column>
              <el-table-column label="星期一" align="center" min-width="220">
                <template slot-scope="{row}">
                  <template v-if="readonly">
                    <div v-for="(i,key) in row.Day1.Dts" :key="key">
                      <span>{{i.Subject}}</span>
                    </div>
                  </template>
                  <template v-else>
                    <div v-for="(item,key) in row.Day1.Dts" :key="key" class="select-subject">
                      <el-select size="mini" v-model="item.SubjectId" @change="cs(item)" clearable>
                        <template v-for="(s,i) in subList">
                          <el-option :key="i" :value="s.SubjectId" :label="s.Subject"></el-option>
                        </template>
                      </el-select>
                      <div style="width: 5px;"></div>
                      <el-select size="mini" v-model="item.TeacherId" @change="ct(item)">
                        <template v-for="(t,i) in item.Teachers">
                          <el-option :key="i" :value="t.TeacherId" :label="t.Teacher"></el-option>
                        </template>
                      </el-select>
                      <div class="btn-close" @click="delSubject(row.Day1,key)">
                        <span class="el-icon-error"></span>
                      </div>
                    </div>
                    <div class="btn-plus" @click="addSubject(row.Day1)">
                      <span class="el-icon-circle-plus"></span>
                    </div>
                  </template>
                </template>
              </el-table-column>
              <el-table-column label="星期二" align="center" min-width="220">
                <template slot-scope="{row}">
                  <template v-if="readonly">
                    <div v-for="(i,key) in row.Day2.Dts" :key="key">
                      <span>{{i.Subject}}</span>
                    </div>
                  </template>
                  <template v-else>
                    <div v-for="(item,key) in row.Day2.Dts" :key="key" class="select-subject">
                      <el-select size="mini" v-model="item.SubjectId" @change="cs(item)" clearable>
                        <template v-for="(s,i) in subList">
                          <el-option :key="i" :value="s.SubjectId" :label="s.Subject"></el-option>
                        </template>
                      </el-select>
                      <div style="width: 5px;"></div>
                      <el-select size="mini" v-model="item.TeacherId" @change="ct(item)">
                        <template v-for="(t,i) in item.Teachers">
                          <el-option :key="i" :value="t.TeacherId" :label="t.Teacher"></el-option>
                        </template>
                      </el-select>
                      <div class="btn-close" @click="delSubject(row.Day2,key)">
                        <span class="el-icon-error"></span>
                      </div>
                    </div>
                    <div class="btn-plus" @click="addSubject(row.Day2)">
                      <span class="el-icon-circle-plus"></span>
                    </div>
                  </template>
                </template>
              </el-table-column>
              <el-table-column label="星期三" align="center" min-width="220">
                <template slot-scope="{row}">
                  <template v-if="readonly">
                    <div v-for="(i,key) in row.Day3.Dts" :key="key">
                      <span>{{i.Subject}}</span>
                    </div>
                  </template>
                  <template v-else>
                    <div v-for="(item,key) in row.Day3.Dts" :key="key" class="select-subject">
                      <el-select size="mini" v-model="item.SubjectId" @change="cs(item)" clearable>
                        <template v-for="(s,i) in subList">
                          <el-option :key="i" :value="s.SubjectId" :label="s.Subject"></el-option>
                        </template>
                      </el-select>
                      <div style="width: 5px;"></div>
                      <el-select size="mini" v-model="item.TeacherId" @change="ct(item)">
                        <template v-for="(t,i) in item.Teachers">
                          <el-option :key="i" :value="t.TeacherId" :label="t.Teacher"></el-option>
                        </template>
                      </el-select>
                      <div class="btn-close" @click="delSubject(row.Day3,key)">
                        <span class="el-icon-error"></span>
                      </div>
                    </div>
                    <div class="btn-plus" @click="addSubject(row.Day3)">
                      <span class="el-icon-circle-plus"></span>
                    </div>
                  </template>
                </template>
              </el-table-column>
              <el-table-column label="星期四" align="center" min-width="220">
                <template slot-scope="{row}">
                  <template v-if="readonly">
                    <div v-for="(i,key) in row.Day4.Dts" :key="key">
                      <span>{{i.Subject}}</span>
                    </div>
                  </template>
                  <template v-else>
                    <div v-for="(item,key) in row.Day4.Dts" :key="key" class="select-subject">
                      <el-select size="mini" v-model="item.SubjectId" @change="cs(item)" clearable>
                        <template v-for="(s,i) in subList">
                          <el-option :key="i" :value="s.SubjectId" :label="s.Subject"></el-option>
                        </template>
                      </el-select>
                      <div style="width: 5px;"></div>
                      <el-select size="mini" v-model="item.TeacherId" @change="ct(item)">
                        <template v-for="(t,i) in item.Teachers">
                          <el-option :key="i" :value="t.TeacherId" :label="t.Teacher"></el-option>
                        </template>
                      </el-select>
                      <div class="btn-close" @click="delSubject(row.Day4,key)">
                        <span class="el-icon-error"></span>
                      </div>
                    </div>
                    <div class="btn-plus" @click="addSubject(row.Day4)">
                      <span class="el-icon-circle-plus"></span>
                    </div>
                  </template>
                </template>
              </el-table-column>
              <el-table-column label="星期五" align="center" min-width="220">
                <template slot-scope="{row}">
                  <template v-if="readonly">
                    <div v-for="(i,key) in row.Day5.Dts" :key="key">
                      <span>{{i.Subject}}</span>
                    </div>
                  </template>
                  <template v-else>
                    <div v-for="(item,key) in row.Day5.Dts" :key="key" class="select-subject">
                      <el-select size="mini" v-model="item.SubjectId" @change="cs(item)" clearable>
                        <template v-for="(s,i) in subList">
                          <el-option :key="i" :value="s.SubjectId" :label="s.Subject"></el-option>
                        </template>
                      </el-select>
                      <div style="width: 5px;"></div>
                      <el-select size="mini" v-model="item.TeacherId" @change="ct(item)">
                        <template v-for="(t,i) in item.Teachers">
                          <el-option :key="i" :value="t.TeacherId" :label="t.Teacher"></el-option>
                        </template>
                      </el-select>
                      <div class="btn-close" @click="delSubject(row.Day5,key)">
                        <span class="el-icon-error"></span>
                      </div>
                    </div>
                    <div class="btn-plus" @click="addSubject(row.Day5)">
                      <span class="el-icon-circle-plus"></span>
                    </div>
                  </template>
                </template>
              </el-table-column>
              <el-table-column label="星期六" align="center" min-width="220">
                <template slot-scope="{row}">
                  <template v-if="readonly">
                    <div v-for="(i,key) in row.Day6.Dts" :key="key">
                      <span>{{i.Subject}}</span>
                    </div>
                  </template>
                  <template v-else>
                    <div v-for="(item,key) in row.Day6.Dts" :key="key" class="select-subject">
                      <el-select size="mini" v-model="item.SubjectId" @change="cs(item)" clearable>
                        <template v-for="(s,i) in subList">
                          <el-option :key="i" :value="s.SubjectId" :label="s.Subject"></el-option>
                        </template>
                      </el-select>
                      <div style="width: 5px;"></div>
                      <el-select size="mini" v-model="item.TeacherId" @change="ct(item)">
                        <template v-for="(t,i) in item.Teachers">
                          <el-option :key="i" :value="t.TeacherId" :label="t.Teacher"></el-option>
                        </template>
                      </el-select>
                      <div class="btn-close" @click="delSubject(row.Day6,key)">
                        <span class="el-icon-error"></span>
                      </div>
                    </div>
                    <div class="btn-plus" @click="addSubject(row.Day6)">
                      <span class="el-icon-circle-plus"></span>
                    </div>
                  </template>
                </template>
              </el-table-column>
              <el-table-column label="星期日" align="center" min-width="220">
                <template slot-scope="{row}">
                  <template v-if="readonly">
                    <div v-for="(i,key) in row.Day7.Dts" :key="key">
                      <span>{{i.Subject}}</span>
                    </div>
                  </template>
                  <template v-else>
                    <div v-for="(item,key) in row.Day7.Dts" :key="key" class="select-subject">
                      <el-select size="mini" v-model="item.SubjectId" @change="cs(item)" clearable>
                        <template v-for="(s,i) in subList">
                          <el-option :key="i" :value="s.SubjectId" :label="s.Subject"></el-option>
                        </template>
                      </el-select>
                      <div style="width: 5px;"></div>
                      <el-select size="mini" v-model="item.TeacherId" @change="ct(item)">
                        <template v-for="(t,i) in item.Teachers">
                          <el-option :key="i" :value="t.TeacherId" :label="t.Teacher"></el-option>
                        </template>
                      </el-select>
                      <div class="btn-close" @click="delSubject(row.Day7,key)">
                        <span class="el-icon-error"></span>
                      </div>
                    </div>
                    <div class="btn-plus" @click="addSubject(row.Day7)">
                      <span class="el-icon-circle-plus"></span>
                    </div>
                  </template>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
      </template>
      <template slot="footer" v-if="readonly">
        <el-button size="mini" @click="close">关 闭</el-button>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import weekPicker from "@/components/common/weekPicker";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    weekPicker,
  },
  data() {
    return {
      data: {
        ClassId: 0,
        TermId: null,
        TermName: "",
        GradeId: null,
        Grade: "",
        Class: "",

        WeekStartDate: "",
        WeekEndDate: "",
        SerialNumber: 0,
        Sections: [],
      },
      Teachers: [],
      // Week: this.$commonJs.getToday(),
      TermStart: "",
      TermEnd: "",
      api: require("@/api/ed/timetable").default,
      subApi: require("@/api/ed/subject").default,
      termApi: require("@/api/ed/term").default,
      isMB: this.$store.state.isMB,
      ClassName: "",
      subList: [],
      readonly: false,
      rules: {
        // TermId: [{ required: true, message: "请选择学期" }],
        // ClassName: [{ required: true, message: "请填写班级" }],
      },
    };
  },
  computed: {},
  methods: {
    onEditOpened(row) {
      console.log("edit", row);
      this.data.ClassId = row.ClassId;
      this.ClassName = row.ClassName;
      this.getTerm();
    },
    onDeatilsOpened(row) {
      console.log("details", row);
      this.readonly = true;
      this.data.ClassId = row.ClassId;
      this.ClassName = row.ClassName;
      this.getTerm();
    },
    onBeforeSave() {
      var data = {
        ClassId: this.data.ClassId,
        WeekStartDate: this.data.WeekStartDate,
        WeekEndDate: this.data.WeekEndDate,
        Sections: [],
      };
      data.Sections = this.data.Sections.map((x) => {
        var item = {
          SectionId: x.SectionId,
          SectionName: x.SectionName,
          Timetables: [],
        };
        for (let i = 1; i <= 7; i++) {
          var tt = { ...x["Day" + i] };
          tt.Dts = tt.Dts.filter((x) => x.T != null && x.SubjectId != null);
          tt.Dts = tt.Dts.map((x) => {
            var item = { ...x };
            if (item.TeacherId == null) item.TeacherId = 0;
            return item;
          });
          tt.DelDts.forEach((x) => {
            if (x.TeacherId == null) x.TeacherId = 0;
            if (x.SubjectId == null) x.SubjectId = 0;
            tt.Dts.push(x);
          });
          item.Timetables.push(tt);
        }
        return item;
      });
      console.log("before-save", data);
      this.api.saveV2(data).then((res) => {
        console.log("api.saveV2", res);
        if (res.Code == 0) {
          this.$message.success(res.Msg);
          this.close(true);
          this.$emit("close-saved");
        } else {
          this.$message.error(res.Msg);
        }
      });
      return false;
    },
    getTerm() {
      this.data.TermId = sessionStorage.getItem("termId");
      var term = this.termApi.info(this.data.TermId).then((res) => {
        if (res.Code == 0) {
          this.TermStart = this.$commonJs.toDateString(res.Data.StartTime);
          this.TermEnd = this.$commonJs.toDateString(res.Data.EndTime);
        }
        this.$refs.weekPicker.init();
        // this.getTimetable();
      });
    },
    getTimetable() {
      console.log("getTimetable");
      if (this.data.ClassId != 0) {
        var c = this.data.ClassId;
        var s = this.data.WeekStartDate;
        var e = this.data.WeekEndDate;
        this.api.getTimetableV2(c, s, e).then((res) => {
          if (res.Data) {
            this.data.Sections = [];
            // console.log("res.Data", JSON.parse(JSON.stringify(res.Data)));
            res.Data.forEach((x) => {
              var section = {
                SectionId: x.SectionId,
                SectionName: x.SectionName,
                Day1: null,
                Day2: null,
                Day3: null,
                Day4: null,
                Day5: null,
                Day6: null,
                Day7: null,
              };
              x.Timetables.forEach((t, i) => {
                t.SectionId = x.SectionId;
                t.Dts = t.Dts.map((x) => {
                  var item = { ...x, T: null, Teachers: [] };
                  if (item.SubjectId == 0) {
                    item.SubjectId = null;
                  } else {
                    if (item.TeacherId == 0) item.TeacherId = null;
                    item.Teachers = this.Teachers.filter(
                      (x) => x.Subject == item.Subject
                    );
                  }
                  return item;
                });
                section["Day" + (i + 1)] = { ...t, DelDts: [] };
              });
              this.data.Sections.push(section);
            });
            // console.log(this.data.Sections.length);
            console.log("Sections", JSON.parse(JSON.stringify(this.data)));
            this.getSubjects();
          }
        });
      }
    },
    getSubjects() {
      this.subApi.list({ PageSize: 100, PageIndex: 1 }).then((res) => {
        if (res.Data) this.subList = res.Data;
        // console.log("subject");
      });
    },
    getTeacher() {
      var termId = this.data.TermId;
      var classId = this.data.ClassId;
      this.api.getTeacher(termId, classId, "").then((res) => {
        console.log("getTeacher", res);
        if (res.Code == 0) this.Teachers = res.Data;
        this.getTimetable();
      });
    },
    cs(dt) {
      dt.T = dt.T == 0 ? 0 : 1;
      var s = this.subList.find((x) => x.SubjectId == dt.SubjectId);
      dt.Subject = s.Subject;
      dt.TeacherId = null;
      dt.Teachers = this.Teachers.filter((x) => x.Subject == s.Subject);
      if (dt.Teachers.length > 0) dt.TeacherId = dt.Teachers[0].TeacherId;
      console.log("changeSubject", dt);
    },
    ct(dt) {
      dt.T = dt.T == 0 ? 0 : 1;
    },
    addSubject(day) {
      day.Dts.push({
        TimetableDtsId: 0,
        TimetableId: 0,
        WeekDay: day.WeekDay,
        GradeId: day.GradeId,
        ClassId: day.ClassId,
        ClassName: day.ClassName,
        GradeSn: day.GradeSn,
        ClassSn: day.ClassSn,
        WeekStartDate: day.WeekStartDate,
        SectionId: day.SectionId,
        SectionName: day.SectionName,
        SectionNumber: day.SectionNumber,
        TimetableDate: day.TimetableDate,
        SubjectId: null,
        Subject: "",
        TeacherId: null,
        Teacher: "",
        TeacherNumber: day.TeacherNumber,
        CreateTime: day.CreateTime,
        T: 0,
      });
    },
    delSubject(day, key) {
      console.log("delSubject", day, key);
      var item = day.Dts[key];
      if (item.T != 0) {
        day.DelDts.push({ ...item, T: 2 });
      }
      day.Dts.splice(key, 1);
    },
    onChange(data) {
      console.log("week", data);
      this.data.WeekStartDate = data.start;
      this.data.WeekEndDate = data.end;
      this.getTeacher();
    },
    onClosed() {
      this.data.Sections = [];
      this.data.Name = "";
      this.data.TermId = null;
      this.data.TermName = "";
      this.Teachers = [];
    },
  },
};
</script>
<style lang="scss" scoped>
.select-subject {
  margin-bottom: 3px;
  display: flex;
  .btn-close {
    line-height: 28px;
    margin-left: 3px;
    color: #f56c6c;
    cursor: pointer;
  }
}
.btn-plus {
  border: 1px solid #b4d6a4;
  color: #67c23a;
  line-height: 14px;
  font-size: 12px;
  padding-top: 1px;
  margin-right: 17px;
  cursor: pointer;
}
</style>